import React, { useState, useEffect } from 'react';
import { useSidebar } from '../SidebarContext';
import Select from 'react-select';
import RequestLeaveModal from './RequestLeaveModal';
import staffImg from '../Img/User img2.png'

const salaryData = [
    {
        year: "2024", months: [
            {
                month: "March 2024",
                idName: "John Doe",
                originalSalary: 15000,
                details: [
                    { label: "Total days", value: 31 },
                    { label: "Present days", value: 20 },
                    { label: "Absent days", value: -3 },
                    { label: "Week off", value: 4 },
                    { label: "Public holiday", value: 2 },
                    { label: "Paid Leave", value: 2 }
                ],
                leaveInfo: ["Reason 1", "Reason 2", "Reason 3"]
            },
            {
                month: "April 2024",
                idName: "Jane Smith",
                originalSalary: 16500,
                details: [
                    { label: "Total days", value: 30 },
                    { label: "Present days", value: 18 },
                    { label: "Absent days", value: -4 },
                    { label: "Week off", value: 4 },
                    { label: "Public holiday", value: 2 },
                    { label: "Paid Leave", value: 2 }
                ],
                leaveInfo: ["Point A", "Point B", "Point C"]
            },
            {
                month: "May 2024",
                idName: "Michael Johnson",
                originalSalary: 16000,
                details: [
                    { label: "Total days", value: 31 },
                    { label: "Present days", value: 19 },
                    { label: "Absent days", value: -2 },
                    { label: "Week off", value: 5 },
                    { label: "Public holiday", value: 1 },
                    { label: "Paid Leave", value: 4 }
                ],
                leaveInfo: ["Detail 1", "Detail 2", "Detail 3"]
            },
            {
                month: "June 2024",
                idName: "Emily Davis",
                originalSalary: 15500,
                details: [
                    { label: "Total days", value: 30 },
                    { label: "Present days", value: 21 },
                    { label: "Absent days", value: -1 },
                    { label: "Week off", value: 4 },
                    { label: "Public holiday", value: 1 },
                    { label: "Paid Leave", value: 3 }
                ],
                leaveInfo: ["Info 1", "Info 2", "Info 3"]
            },
            {
                month: "July 2024",
                idName: "David Wilson",
                originalSalary: 17000,
                details: [
                    { label: "Total days", value: 31 },
                    { label: "Present days", value: 22 },
                    { label: "Absent days", value: -3 },
                    { label: "Week off", value: 4 },
                    { label: "Public holiday", value: 1 },
                    { label: "Paid Leave", value: 1 }
                ],
                leaveInfo: ["Point X", "Point Y", "Point Z"]
            },
            {
                month: "August 2024",
                idName: "Sarah Miller",
                originalSalary: 16000,
                details: [
                    { label: "Total days", value: 31 },
                    { label: "Present days", value: 23 },
                    { label: "Absent days", value: -2 },
                    { label: "Week off", value: 4 },
                    { label: "Public holiday", value: 2 },
                    { label: "Paid Leave", value: 2 }
                ],
                leaveInfo: ["Note 1", "Note 2", "Note 3"]
            },
            {
                month: "September 2024",
                idName: "John Doe",
                originalSalary: 15000,
                details: [
                    { label: "Total days", value: 30 },
                    { label: "Present days", value: 18 },
                    { label: "Absent days", value: -3 },
                    { label: "Week off", value: 5 },
                    { label: "Public holiday", value: 2 },
                    { label: "Paid Leave", value: 2 }
                ],
                leaveInfo: ["Detail A", "Detail B", "Detail C"]
            },
            {
                month: "October 2024",
                idName: "Jane Smith",
                originalSalary: 16500,
                details: [
                    { label: "Total days", value: 31 },
                    { label: "Present days", value: 20 },
                    { label: "Absent days", value: -2 },
                    { label: "Week off", value: 4 },
                    { label: "Public holiday", value: 1 },
                    { label: "Paid Leave", value: 3 }
                ],
                leaveInfo: ["Point A1", "Point B1", "Point C1"]
            },
            {
                month: "November 2024",
                idName: "Michael Johnson",
                originalSalary: 16000,
                details: [
                    { label: "Total days", value: 30 },
                    { label: "Present days", value: 19 },
                    { label: "Absent days", value: -3 },
                    { label: "Week off", value: 5 },
                    { label: "Public holiday", value: 1 },
                    { label: "Paid Leave", value: 2 }
                ],
                leaveInfo: ["Info 4", "Info 5", "Info 6"]
            },
            {
                month: "December 2024",
                idName: "Emily Davis",
                originalSalary: 15500,
                details: [
                    { label: "Total days", value: 31 },
                    { label: "Present days", value: 21 },
                    { label: "Absent days", value: -2 },
                    { label: "Week off", value: 4 },
                    { label: "Public holiday", value: 1 },
                    { label: "Paid Leave", value: 3 }
                ],
                leaveInfo: ["Detail X", "Detail Y", "Detail Z"]
            },
        ]
    },
    {
        year: "2025", months: [
            {
                month: "January 2025",
                idName: "David Wilson",
                originalSalary: 17000,
                details: [
                    { label: "Total days", value: 31 },
                    { label: "Present days", value: 22 },
                    { label: "Absent days", value: -3 },
                    { label: "Week off", value: 4 },
                    { label: "Public holiday", value: 1 },
                    { label: "Paid Leave", value: 1 }
                ],
                leaveInfo: ["Note A", "Note B", "Note C"]
            },
            {
                month: "February 2025",
                idName: "Sarah Miller",
                originalSalary: 16000,
                details: [
                    { label: "Total days", value: 28 },
                    { label: "Present days", value: 24 },
                    { label: "Absent days", value: -2 },
                    { label: "Week off", value: 4 },
                    { label: "Public holiday", value: 2 },
                    { label: "Paid Leave", value: 2 }
                ],
                leaveInfo: ["Detail P", "Detail Q", "Detail R"]
            },
            {
                month: "March 2025",
                idName: "John Doe",
                originalSalary: 15000,
                details: [
                    { label: "Total days", value: 31 },
                    { label: "Present days", value: 20 },
                    { label: "Absent days", value: -3 },
                    { label: "Week off", value: 4 },
                    { label: "Public holiday", value: 2 },
                    { label: "Paid Leave", value: 2 }
                ],
                leaveInfo: ["Reason X", "Reason Y", "Reason Z"]
            }
        ]
    }
];


const SalaryDetail = () => {

    const [openMonth, setOpenMonth] = useState(null);
    const [openYear, setOpenYear] = useState(null);
    const [selectedYear, setSelectedYear] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleYear = (year) => {
        setOpenYear(openYear === year ? null : year);
        setOpenMonth(null); // Reset months when switching years
    };

    const toggleMonth = (month) => {
        setOpenMonth(openMonth === month ? null : month);
    };

    const yearOptions = salaryData.map(({ year }) => ({
        value: year,
        label: year
    }));

    // Filter salary data based on selected year
    const filteredData = selectedYear
        ? salaryData.filter(({ year }) => year === selectedYear.value)
        : salaryData;

    return (
        <>
            <div className="salary-details">
                <div className="salary-header-container-hboms">
                    {/* Left Section - Profile Info */}
                    <div className="salary-header-profile-hboms">
                        <div className="salary-header-pic-hboms">
                            <img src={staffImg} alt="" />
                        </div>
                        <div className="salary-header-info-hboms">
                            <h2 className="salary-header-id-hboms">0001</h2>
                            <h2 className="salary-header-name-hboms">Vishal</h2>
                            <p className="salary-header-role-hboms">Sales person</p>
                        </div>
                    </div>

                    {/* Right Section - Help Button */}
                    <div className="salary-header-right-profile">
                        <button className="salary-header-button-hboms">Help</button>
                        <p className="request-for-leave" onClick={() => setIsModalOpen(true)}>
                            Request for leave
                        </p>
                    </div>
                </div>

                <div className="salary-filter">
                    <Select
                        options={[{ value: null }, ...yearOptions]}
                        onChange={setSelectedYear}
                        placeholder="Filter by Year"
                        isClearable
                    />
                </div>

                <div className="salary-accordion">
                    {filteredData.map(({ year, months }) => (
                        <div key={year} className="salary-year-section">
                            <button
                                className="salary-year-toggle"
                                onClick={() => toggleYear(year)}
                            >
                                {year} <i className={`fa-solid ${openYear === year ? "fa-chevron-up" : "fa-chevron-down"}`}></i>
                            </button>

                            {openYear === year && (
                                <div className="salary-months-wrapper">
                                    {months.map(({ month, originalSalary, details, leaveInfo }) => {
                                        const perDayoriginalSalary = originalSalary / details.find(d => d.label === 'Total days').value;
                                        const totalPaidAmount = details.reduce((sum, d) => {
                                            const { label, value } = d;
                                            if (["Present days", "Paid Leave", "Public holiday", "Week off"].includes(label)) {
                                                return sum + value * perDayoriginalSalary;
                                            } else if (label === "Absent days") {
                                                return sum - Math.abs(value * perDayoriginalSalary);
                                            }
                                            return sum;
                                        }, 0);

                                        return (
                                            <div key={month} className="salary-hboms-month">
                                                <button
                                                    className="salary-hboms-toggle"
                                                    onClick={() => toggleMonth(month)}
                                                    aria-expanded={openMonth === month}
                                                >
                                                    {month}
                                                    <i className={`fa-solid ${openMonth === month ? "fa-chevron-up" : "fa-chevron-down"}`}></i>
                                                </button>

                                                {openMonth === month && (
                                                    <div className="salary-hboms-content">
                                                        <div className="salary-hboms-card">
                                                            <div className="salary-hboms-body">
                                                                <h2>₹{totalPaidAmount.toFixed(2)}</h2>
                                                                <button className="salary-hboms-highlight">₹{originalSalary.toLocaleString()}</button>
                                                                <ul>
                                                                    {details.map(({ label, value }, index) => {
                                                                        let amount = 0;
                                                                        if (["Present days", "Paid Leave", "Public holiday", "Week off"].includes(label)) {
                                                                            amount = value * perDayoriginalSalary;
                                                                        } else if (label === "Absent days") {
                                                                            amount = -Math.round(Math.abs(value) * perDayoriginalSalary);
                                                                        }
                                                                        return (
                                                                            <li key={index}>
                                                                                {label} ({value})
                                                                                {label === "Total days" ? (
                                                                                    <span> ₹{originalSalary.toLocaleString()}</span>
                                                                                ) : (
                                                                                    <span> ₹{amount.toFixed(2)}</span>
                                                                                )}
                                                                            </li>
                                                                        );
                                                                    })}
                                                                </ul>
                                                                <hr />
                                                                <div className="salary-hboms-leave-info">
                                                                    <strong>Paid leave info</strong>
                                                                    <ul>
                                                                        {leaveInfo.map((point, index) => (
                                                                            <li key={index}>{index + 1}. {point}</li>
                                                                        ))}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>

            <RequestLeaveModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} />
        </>
    );
};

export default SalaryDetail;
